import { ArrowBack } from "@mui/icons-material"
import { TitleContainer, TitleLabel } from './styles';
import { ColumnItem, ReturnToList, ReturnToListContainer } from "../../../components/ReceiptDetailHeader/styles"
import SingleStatus from "../../ReceiptsItem/components/SingleStatus";
import { RECEIPT_STEPS, RECEIPT_STEPS_TRANSKEY } from "./stepEnum";
import { useState } from "react";

export const ReceiptDetailHistory = ({
  onReturnToDetail,
  date,
  history
}) => {
  const [historyReverse,] = useState(() => {
    const newArray = [...history];
    newArray.reverse();
    return newArray;
  });

  return (
    <div>
      <ReturnToListContainer>
        <ColumnItem>
          <ReturnToList onClick={() => onReturnToDetail()}>
            <ArrowBack />
            Voltar para a foto
          </ReturnToList>
        </ColumnItem>
      </ReturnToListContainer>
      
      <TitleContainer>
        <TitleLabel>
          Histórico
        </TitleLabel>
      </TitleContainer>

      <>
        <SingleStatus
          changedStatusAt={date}
          first={true}
          last={history.length === 0}
          title={RECEIPT_STEPS_TRANSKEY[RECEIPT_STEPS.ADDED]}
          vertical={true}
        />
        {historyReverse.map((item, index) => (
          <SingleStatus
            key={`${item.title}-${item.date}`}
            changedStatusAt={item.date}
            last={index === history.length - 1}
            title={RECEIPT_STEPS_TRANSKEY[item.title]}
            justification={item.justification}
            user={item.user}
            vertical={true}
          />
        ))}
      </>
    </div>
  )
}
